import React, { Dispatch, memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { ExecutorRate } from "../../../../services";
import {
	useExecutorRateSubHandler,
	useTaxiServiceFilterAccessControl,
} from "../../../../hooks";
import MultiSelectWithModalBase, {
	MultiSelectWithModal,
} from "../MultiSelectWithModal";

const MultiSelectCommissionPlanWithModalBase: React.FC<
	MultiSelectCommissionPlanWithModalBase.Props
> = ({
	value,
	onChange,
	disabled,
	titleText,
	required,
	modalSetting,
	sort,
	allowedTaxiServiceIds,
	all = true,
	accessIds,
	showLable,
	...props
}) => {
	const { t } = useTranslation();

	const { accessTaxiServicesIds } = useTaxiServiceFilterAccessControl<any>();
	const { getAllExecutorRateSubHandler } = useExecutorRateSubHandler();

	const optionsSubscribe: ExecutorRate.SubscribeOptions = useMemo(
		() => ({
			...(allowedTaxiServiceIds || accessTaxiServicesIds
				? {
						taxiServiceIds:
							allowedTaxiServiceIds || accessTaxiServicesIds,
				  }
				: {}),
		}),
		[accessTaxiServicesIds, allowedTaxiServiceIds],
	);

	const modelItems = useMemo(() => {
		const retval = getAllExecutorRateSubHandler(optionsSubscribe);

		return retval;
	}, [getAllExecutorRateSubHandler, optionsSubscribe]);

	const items = useMemo(() => modelItems || [], [modelItems]);

	const [error, setError] = useState("");

	const selectOptions = useMemo<MultiSelectWithModalBase.Value>(
		() =>
			items.map((item, index) => ({
				key: item.id,
				label: item.name ?? "",
				value: item.id,
				name: item.name ?? "",
				data: item,
			})),
		[items],
	);

	const selected = useMemo<MultiSelectWithModalBase.Value>(
		() =>
			selectOptions.filter((item) =>
				value.find((data) => data === item.value),
			),

		[selectOptions, value],
	);

	const selectOnChange = useCallback(
		(newValue) => {
			setError("");
			const Ids = newValue.map((item) => item.value);
			onChange(Ids);
		},
		[onChange],
	);

	const texts = useMemo(
		() => ({
			title: t(titleText),
			// allText: t(["all_car_parks"]),
			// allActiveText: t(["all_active_car_parks"]),
		}),
		[t, titleText],
	);

	return (
		<MultiSelectWithModal
			error={error}
			disabled={disabled}
			value={selected}
			title={texts.title}
			// allText={all ? texts.allText : undefined}
			// allActiveText={texts.allActiveText}
			options={selectOptions}
			onChange={selectOnChange}
			required={required}
			pullUpItemInsideArray
			hiddenButton={false}
			showSelectAll
			modalSetting={modalSetting}
			sort={{
				show: true,
				active: true,
				...(sort || {}),
			}}
			showLable={showLable}
			{...props}
		/>
	);
};

export const MultiSelectCommissionPlanWithModal = memo(
	MultiSelectCommissionPlanWithModalBase,
);

declare namespace MultiSelectCommissionPlanWithModalBase {
	interface Props extends MultiSelectWithModalBase.Setting {
		value: Value;
		onChange: Dispatch<Value>;
		titleText: string | string[];
		modalSetting?: MultiSelectWithModalBase.ListSelectProps["modalSetting"];
		setShowModalProps?: (value: boolean) => void;
		allowedTaxiServiceIds?: number[];
		all?: boolean;
		accessIds?: number[];
		showLable?: boolean;
	}

	type Value = number[];
}

export default MultiSelectCommissionPlanWithModalBase;
